/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CancelServiceOrdreResponseDto as OkEgisServiceEksternModelsDtoCancelServiceOrdreResponseDto } from '../models/OK/EGIS/Service/Ekstern/Models/DTO/cancel-service-ordre-response-dto';
import { CreateServiceOrdreResponseDto as OkEgisServiceEksternModelsDtoCreateServiceOrdreResponseDto } from '../models/OK/EGIS/Service/Ekstern/Models/DTO/create-service-ordre-response-dto';
import { CreateServiceordreRequestDto as OkEgisServiceEksternModelsDtoCreateServiceordreRequestDto } from '../models/OK/EGIS/Service/Ekstern/Models/DTO/create-serviceordre-request-dto';
import { SearchServiceaftalerRequestDto as OkEgisServiceEksternModelsDtoSearchServiceaftalerRequestDto } from '../models/OK/EGIS/Service/Ekstern/Models/DTO/search-serviceaftaler-request-dto';
import { SearchServiceaftalerResponseDto as OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto } from '../models/OK/EGIS/Service/Ekstern/Models/DTO/search-serviceaftaler-response-dto';

@Injectable({
  providedIn: 'root',
})
export class EgisService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation searchServiceaftaler
   */
  static readonly SearchServiceaftalerPath = '/api/v1/Egis/SearchServiceaftaler';

  /**
   * [Roles: Client]
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchServiceaftaler()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchServiceaftaler$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceEksternModelsDtoSearchServiceaftalerRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, EgisService.SearchServiceaftalerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto>;
      })
    );
  }

  /**
   * [Roles: Client]
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchServiceaftaler$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchServiceaftaler(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceEksternModelsDtoSearchServiceaftalerRequestDto
  }): Observable<OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto> {

    return this.searchServiceaftaler$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto>) => r.body as OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto)
    );
  }

  /**
   * Path part for operation serviceaftaleHistory
   */
  static readonly ServiceaftaleHistoryPath = '/api/v1/Egis/ServiceaftaleHistory';

  /**
   * [Roles: Client]
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceaftaleHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceaftaleHistory$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, EgisService.ServiceaftaleHistoryPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto>;
      })
    );
  }

  /**
   * [Roles: Client]
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `serviceaftaleHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceaftaleHistory(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto> {

    return this.serviceaftaleHistory$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto>) => r.body as OkEgisServiceEksternModelsDtoSearchServiceaftalerResponseDto)
    );
  }

  /**
   * Path part for operation createServiceordre
   */
  static readonly CreateServiceordrePath = '/api/v1/Egis/CreateServiceordre';

  /**
   * [Roles: Client]
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createServiceordre()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createServiceordre$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceEksternModelsDtoCreateServiceordreRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceEksternModelsDtoCreateServiceOrdreResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, EgisService.CreateServiceordrePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceEksternModelsDtoCreateServiceOrdreResponseDto>;
      })
    );
  }

  /**
   * [Roles: Client]
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createServiceordre$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createServiceordre(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceEksternModelsDtoCreateServiceordreRequestDto
  }): Observable<OkEgisServiceEksternModelsDtoCreateServiceOrdreResponseDto> {

    return this.createServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceEksternModelsDtoCreateServiceOrdreResponseDto>) => r.body as OkEgisServiceEksternModelsDtoCreateServiceOrdreResponseDto)
    );
  }

  /**
   * Path part for operation cancelServiceordre
   */
  static readonly CancelServiceordrePath = '/api/v1/Egis/CancelServiceordre';

  /**
   * [Roles: Client]
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelServiceordre()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelServiceordre$Response(params: {
    serviceordreNo?: number;
    note?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceEksternModelsDtoCancelServiceOrdreResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, EgisService.CancelServiceordrePath, 'post');
    if (params) {
      rb.query('serviceordreNo', params.serviceordreNo, {});
      rb.query('note', params.note, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceEksternModelsDtoCancelServiceOrdreResponseDto>;
      })
    );
  }

  /**
   * [Roles: Client]
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cancelServiceordre$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelServiceordre(params: {
    serviceordreNo?: number;
    note?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceEksternModelsDtoCancelServiceOrdreResponseDto> {

    return this.cancelServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceEksternModelsDtoCancelServiceOrdreResponseDto>) => r.body as OkEgisServiceEksternModelsDtoCancelServiceOrdreResponseDto)
    );
  }

}
